@if(view=='list')
{
<app-iamge-list>

</app-iamge-list>
}
    @else{
    <app-image-thumbnail></app-image-thumbnail>
    }
